<template>
    <div class="locations-group">
    <template v-for="(location, index) in data">
      <div :class="['location-item',getFocusIndexClass(index)]" :key="location.id">
        <template v-for="(locationItem, locationKey) in location.questions">
          <template v-if="locationItem.questionID">
            <number-select-input-two 
              v-if="getQuestionJSON(locationItem.questionID).inputType == 'n'"
              :key="locationItem.questionID"
              :data1="locationItem.value+''"
              :examination_typeID="examination_typeID"
              :label="distance(examination_typeID)"
              :float="false"
              :unit="'cm'"
              @locationChange="$emit('locationChange', { id: location.id, column: locationKey, value: $event })"
            ></number-select-input-two>
            <v-select
              v-else
              :key="locationItem.questionID"
              v-model="locationItem.value" 
              :items="getLocationItems(locationItem)" 
              :label="getLocationSelectLabel(locationItem.questionID)"
              @change="$emit('locationChange', { id: location.id, column: locationKey, value: $event })"
              hide-details 
            ></v-select>
          </template>
        </template>
        <div class="action-btn">
          <v-btn
            v-if="index === 0"
            class="add-location-btn"
            icon
            flat
            small
            @click="$emit('addLocation')"
          >
            <v-icon>add</v-icon>
          </v-btn>

          <v-btn
            v-else
            class="delete-location-btn"
            icon
            flat
            small
            @click="$emit('deleteLocation', location.id)"
          >
            <v-icon>remove</v-icon>
          </v-btn>
        </div>
      </div>
    </template>

    <div class="location-image-container" v-if="!hideLocationImage && data.length === 1">
      <img v-if="getLocationImage(data[0].questions) && (getLocationImage(data[0].questions) !== '')" :src="require(`@/assets/location_image/${getLocationImage(data[0].questions)}`)" />
    </div>
  </div>
</template>

<script>
import forms from '@/utils/forms'
import NumberSelectInputTwo from '@/components/NumberSelectInputTwo.vue'

export default {
    name: 'Locations',

    props: {
        data: {
            required: true,
            type: Array
        },

        questions: {
            required: true,
            type: Object
        },

        hideLocationImage: {
            required: false,
            default: false,
            type: Boolean
        },
        focus: {
            required: false,
            default: false,
            type: Boolean
        },
        focusIndex: {
            required: false,
            type: Number
        },
        examination_typeID:Number
    },
    components: {
      NumberSelectInputTwo,
    },
    data() {
        return {

        }
    },

    methods: {
        getQuestionJSON(qID) {
            return this.questions[qID]
        },

        getLocationItems(item) {
            const question = this.getQuestionJSON(item.questionID)
            const type = question.inputType
            question.options[0] = '';
            return forms.prepareSelectItems(question.options)
        },

        test(d){
          alert(d)
        },

        distance(a){
          if (a ==1){
            return "from incisor"
          }
          else if(a == 2){
            return "AAV"
          }
        },

        getLocationSelectLabel(qID) {
            return this.questions[qID] ? this.questions[qID].question : ''
        },

        getLocationImage: (url) => forms.getLocationImage(url),
        getFocusIndexClass(index) {
            if (this.focusIndex >= 0 && this.focus) {
                return (this.focusIndex == index && this.focus == true) ? 'focus' : ''
            } else {
                return ''
            }

        }
    }
}
</script>

<style lang="scss">
  @import '@/styles/components/locations.scss';
</style>